import React, {
  useEffect,
  Fragment,
  useState,
  createElement,
  useMemo,
  useRef,
} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Nav, Navbar, Row, Col, Spinner } from "react-bootstrap";
import { navbarBreakPoint, topNavbarBreakpoint } from "config";
import Flex from "components/common/Flex";
import Logo from "components/common/Logo";
import NavbarVerticalMenu from "./NavbarVerticalMenu";
import ToggleButton from "./ToggleButton";
import routes from "routes/siteMaps";
import { capitalize } from "helpers/utils";
import NavbarTopDropDownMenus from "components/navbar/top/NavbarTopDropDownMenus";
import PurchaseCard from "./PurchaseCard";
import bgNavbar from "assets/img/generic/bg-navbar.png";
import { useAppContext } from "Main";
import { MenusAPI, RolePermissionsAPI } from "api";
import {
  filterAndSortMenuItems,
  useFilterAndSortMenuItems,
} from "utils/menuUtils";

import * as ReactIcons from "react-icons/bs";
import { FaWpforms } from "react-icons/fa";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import { useSettingContext } from "context/SettingContext";
import { AppVersion, Certificate, customSettings } from "utils/customConfig";

const NavbarVertical = () => {
  const [menuState, setMenuState] = useState([]);
  const [permissionsData, setPermissionsData] = useState([]);
  const [hover, setHover] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [bgColor, setBgColor] = useState("#fff"); // Default background color

  // console.log(collapsed);
  // console.log(hover);

  const { nestedMenuItems } = useFilterAndSortMenuItems();

  const settingsData = useSettingContext();
  const settingCostCenterAndYear = useMemo(
    () =>
      settingsData?.filter(
        (d) =>
          d.name === "DEFAULT_COST_CENTER" || d.name === "DEFAULT_FISCAL_YEAR"
      ),
    [settingsData]
  );

  // console.log(settingCostCenterAndYear);

  // console.log(nestedMenuItems);

  // let structuredMenu = nestedMenuItems?.map((d) => ({
  //   name: d.name,
  //   active: true,
  //   icon: ReactIcons[d.icon] ? createElement(ReactIcons[d.icon]) : null,
  //   children: d.children.map((s) => ({
  //     name: s.name,
  //     icon: ReactIcons[s.icon] ? createElement(ReactIcons[s.icon]) : null,
  //     to: s.url,
  //     exact: true,
  //     active: true,
  //   })),
  // }));

  const mapMenuItems = (items = []) =>
    items.map((item) => ({
      name: item.name,
      icon: ReactIcons[item.icon] ? createElement(ReactIcons[item.icon]) : null,
      to: item.url || undefined,
      exact: true,
      active: true,
      children: item.children?.length ? mapMenuItems(item.children) : undefined,
    }));

  const structuredMenu = mapMenuItems(nestedMenuItems);

  // console.log(structuredMenu);

  let structuredMenuLocal = [
    // {
    //   name: "Accounts",
    //   icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //   active: true,
    //   children: [
    //     {
    //       name: "Cost Center",
    //       to: "/accounts/cost-center",
    //       icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //       exact: true,
    //       active: true,
    //     },
    //     {
    //       name: "Fiscal Year",
    //       to: "/accounts/fiscal-year",
    //       icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //       exact: true,
    //       active: true,
    //     },
    //     {
    //       name: "Chart of Accounts",
    //       to: "/accounts/chart-of-accounts",
    //       icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //       exact: true,
    //       active: true,
    //     },
    //     {
    //       name: "Finance Books",
    //       to: "/accounts/finance-books",
    //       icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //       exact: true,
    //       active: true,
    //     },
    //     {
    //       name: "Vouchers",
    //       to: "/accounts/vouchers",
    //       icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //       exact: true,
    //       active: true,
    //     },
    //   ],
    // },
    // {
    //   name: "Customers",
    //   icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //   to: "/customers",
    //   exact: true,
    //   active: true,
    // },
    // {
    //   name: "Estimates",
    //   icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //   to: "/estimates",
    //   exact: true,
    //   active: true,
    // },
    // {
    //   name: "Get an Estimate ",
    //   icon: createElement(ReactIcons["BsLayoutTextSidebar"]),
    //   to: "/home/get-an-estimate",
    //   exact: true,
    //   active: true,
    // },
  ];

  let combinedMenu = [...(structuredMenu || []), ...structuredMenuLocal];

  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu,
      varticalNavbarHover,
    },
    setConfig,
  } = useAppContext();

  const isCollapsedRef = useRef(isNavbarVerticalCollapsed);

  useEffect(() => {
    isCollapsedRef.current = isNavbarVerticalCollapsed;
  }, [isNavbarVerticalCollapsed]);

  // console.log("isNavbarVerticalCollapsed", isNavbarVerticalCollapsed);

  const HTMLClassList = document.getElementsByTagName("html")[0].classList;

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add("navbar-vertical-collapsed");
    } else {
      HTMLClassList.remove("navbar-vertical-collapsed");
    }
    return () => {
      HTMLClassList.remove("navbar-vertical-collapsed-hover");
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  // const handleMouseEnter = () => {
  //   // console.log("enter");
  //   setHover(true);
  //   if (isNavbarVerticalCollapsed) {
  //     time = setTimeout(() => {
  //       HTMLClassList.add("navbar-vertical-collapsed-hover");
  //     }, 100);
  //   }
  // };

  // const handleMouseLeave = () => {
  //   setHover(false);
  //   clearTimeout(time);
  //   HTMLClassList.remove("navbar-vertical-collapsed-hover");
  // };

  // const handleClick = () => {
  //   // setCollapsed(!collapsed);
  //   const newValue = !isCollapsedRef.current;
  //   document
  //     .getElementsByTagName("html")[0]
  //     .classList.toggle("navbar-vertical-collapsed");
  //   setConfig("isNavbarVerticalCollapsed", newValue);
  //   // setConfig("isNavbarVerticalCollapsed", !isNavbarVerticalCollapsed);
  // };

  // Handle hover interaction
  const hoverTimeoutRef = useRef();

  const handleMouseEnter = () => {
    setConfig("varticalNavbarHover", true);
    if (isNavbarVerticalCollapsed) {
      hoverTimeoutRef.current = setTimeout(() => {
        HTMLClassList.add("navbar-vertical-collapsed-hover");
      }, 100);
    }
  };

  const handleMouseLeave = () => {
    setConfig("varticalNavbarHover", false);
    clearTimeout(hoverTimeoutRef.current);
    HTMLClassList.remove("navbar-vertical-collapsed-hover");
  };

  const handleClick = () => {
    setConfig("varticalNavbarHover", false);
    const newValue = !isCollapsedRef.current;
    // HTMLClassList.toggle("navbar-vertical-collapsed");
    document
      .getElementsByTagName("html")[0]
      .classList.toggle("navbar-vertical-collapsed");
    setConfig("isNavbarVerticalCollapsed", newValue);
    // HTMLClassList.remove("navbar-vertical-collapsed-hover");
  };

  useEffect(() => {
    const handleShortcut = (e) => {
      if (e.key === "[") {
        handleClick();
      }
    };

    // Add the event listener on mount
    window.addEventListener("keydown", handleShortcut);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("keydown", handleShortcut);
    };
  }, []);

  const NavbarLabel = ({ label }) => (
    <Nav.Item as="li">
      <Row className="mt-3 mb-2 navbar-vertical-label-wrapper">
        <Col xs="auto" className="navbar-vertical-label navbar-vertical-label">
          {label}
        </Col>
        <Col className="ps-0">
          <hr className="mb-0 navbar-vertical-divider"></hr>
        </Col>
      </Row>
    </Nav.Item>
  );

  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames("navbar-vertical", {
        [`navbar-${navbarStyle}`]: navbarStyle !== "transparent",
      })}
      variant="light"
    >
      <Flex alignItems="center" className="navbar-large">
        {/* <Flex alignItems="center"> */}
        <ToggleButton />
        <div
          className="fs-8 fw-medium  navbar-logo"
          // style={{ marginLeft: "-18px" }}
        >
          <div className="d-flex align-items-center">
            {/* <Logo
              at="navbar-vertical"
              textClass="text-primary fs-8"
              width={24}
            /> */}
            <span style={{ marginLeft: "-18px" }}>NexusWare</span>
          </div>
        </div>
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage:
            navbarStyle === "vibrant"
              ? `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbar})`
              : "none",
          marginTop: "0px",
          backgroundColor: "#E6F1EE",
          borderRight: "2px solid #E6F1EE",
        }}
      >
        <div
          className="navbar-vertical-content scrollbar"
          // style={{ backgroundColor: "#e8f0fc", paddingTop: "0px" }}
          style={{ paddingTop: "0px", borderRight: "1px solid #E6F1EE" }}
        >
          {/* <Nav className="flex-column" as="ul">
            {routes.map((route) => (
              <Fragment key={route.label}>
                {!route.labelDisable && (
                  <NavbarLabel label={capitalize(route.label)} />
                )}
                <NavbarVerticalMenu routes={route.children} />
              </Fragment>
            ))}
          </Nav> */}

          <Nav
            className="flex-column"
            key=""
            style={{ paddingBottom: "100px" }}
          >
            <Fragment>
              {varticalNavbarHover && (
                <div
                  style={{
                    position: "absolute",
                    top: "10%",
                    width: "auto",
                    right: -15,
                    zIndex: 99999999,

                    // backgroundColor: "#fff",
                    // border: "none",
                    // borderRadius: "100%",
                    cursor: "pointer",
                    opacity: varticalNavbarHover ? 1 : 0, // Control opacity based on hover state
                    transition: "opacity 0.5s ease-in-out", // Smooth transition for opacity
                  }}
                  onClick={handleClick}
                >
                  {isNavbarVerticalCollapsed ? (
                    <IoIosArrowDropright
                      title="Expand ["
                      size={30}
                      className="collapse-icon-custome"
                      style={{ borderRadius: "100%" }}
                    />
                  ) : (
                    <IoIosArrowDropleft
                      title="Collapse ["
                      size={30}
                      className="collapse-icon-custome"
                      style={{ borderRadius: "110%" }}
                    />
                  )}
                </div>
              )}

              {/* {isLoading && <Spinner variant="primary" animation="border" />} */}
              {/* {!route.labelDisable && <NavbarLabel label={route.name} />} */}
              <h6>
                <NavbarVerticalMenu
                  routes={combinedMenu}
                  hover={hover}
                  collapsed={isNavbarVerticalCollapsed}
                />
              </h6>
            </Fragment>
          </Nav>
          {!isNavbarVerticalCollapsed && (
            <>
              <div
                style={{
                  position: "absolute",
                  bottom: "0px", // Position at the bottom
                  // width: "100%",
                  textAlign: "left",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  backgroundColor: "#E6F1EE",
                  fontSize: "14px",
                  fontWeight: "bold",
                  // borderTop: "1px solid #ccc",
                }}
              >
                <div style={{ paddingLeft: "4px" }}>
                  {customSettings?.showCostCenter && (
                    <div>
                      Cost Center:{" "}
                      {
                        settingCostCenterAndYear?.find(
                          (d) => d.name === "DEFAULT_COST_CENTER"
                        )?.value
                      }
                    </div>
                  )}

                  {customSettings?.showFiscalYear && (
                    <div>
                      Fiscal Year:{" "}
                      {
                        settingCostCenterAndYear?.find(
                          (d) => d.name === "DEFAULT_FISCAL_YEAR"
                        )?.value
                      }
                    </div>
                  )}

                  <div
                    className="d-flex align-items-center gap-1"
                    style={{ marginLeft: "6.2px" }}
                  >
                    <Certificate />-{/* <div>&nbsp; - &nbsp;</div> */}
                    <AppVersion />
                  </div>
                </div>
              </div>
            </>
          )}

          <>
            {navbarPosition === "combo" && (
              <div className={`d-${topNavbarBreakpoint}-none`}>
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr my-2" />
                </div>
                <Nav navbar>
                  <NavbarTopDropDownMenus />
                </Nav>
              </div>
            )}
            {/* <PurchaseCard /> */}
          </>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  label: PropTypes.string,
};

export default NavbarVertical;
